export const QUERY_PARAM = {
  TEST_BANNERS: 'testBanners',
  MOCKED_BANNERS: 'mockedBanners',
  HIDE_OPTIN_MONSTER: 'omhide',
  DISABLE_GTM: 'noGtm',
  DISABLE_BROWSER_NEWRELIC: 'noBrowserNewrelic',
  DISABLE_VIDEO_BANNER: 'noVideoBanner',
  HIDE_COOKIE_POPUP: 'hideCookiePopup',
  HIGHLIGHT_CUSTOM_FONT: 'highlightCustomFonts'
}
